module.exports = __webpack_public_path__ + "static/media/settled.a29db353.svg";